import { Box, Image, Stack, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { IMG } from '../../../Content/Content';

const Styles = () => {
    const StylesItem =[
        {
            id:"",
            title:"Style name",
            ImgUrl:IMG.styles1
        },        
        {
            id:"",
            title:"Style name",
            ImgUrl:IMG.styles2
        },        {
            id:"",
            title:"Style name",
            ImgUrl:IMG.styles3
        },        {
            id:"",
            title:"Style name",
            ImgUrl:IMG.styles4
        },        {
            id:"",
            title:"Style name",
            ImgUrl:IMG.styles5
        },
        {
            id:"",
            title:"Style name",
            ImgUrl:IMG.styles6
        },
    ]
    return (
        <VStack>
            <Box textAlign="left" w="100%" paddingTop="40px">
                <Text
                    fontSize="30px"
                    fontWeight="500"
                    color="rgba(0, 0, 0, 0.84)"
                    position="relative" className='Title_product' paddingLeft="20px" _before={{
                        position: "absolute",
                        left: "0",
                        right: "0",
                        height: "100%",
                        background: " linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)",
                        width: "9px"
                    }}>Styles</Text>
            </Box>

            <Stack>
                 <Box display="flex" alignItems="center" flexWrap="wrap" justifyContent="start" w="100%">
                    {
                        StylesItem.map((item)=>(
                           <Box key={item.id} w="25%">
                              <Box margin="15px" textAlign="center">
                              <Image src={item.ImgUrl}/>

                                <Text marginTop="20px"                     
                                fontSize="24px"
                    fontWeight="400"
                    color="rgba(0, 0, 0, 0.84)">{item.title}</Text>
                              </Box>
                           </Box>

                        ))
                    }
                 </Box>
            </Stack>
        </VStack>
    );
};

export default Styles;